import { render, staticRenderFns } from "./ShipmentsAvailable.vue?vue&type=template&id=042ef2ec&scoped=true"
import script from "./ShipmentsAvailable.vue?vue&type=script&lang=js"
export * from "./ShipmentsAvailable.vue?vue&type=script&lang=js"
import style0 from "./ShipmentsAvailable.vue?vue&type=style&index=0&id=042ef2ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042ef2ec",
  null
  
)

export default component.exports